import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';

import { timeout } from 'rxjs';

import { LocalStorageKey } from 'app/shared/enums';

import { environment } from 'environments/environment';

import { RegionalUrlService } from './regional-url.service';
import { SIGNAGE_API } from './signage-api-context';

export const regionInterceptor: HttpInterceptorFn = (request, next) => {
  const regional = inject(RegionalUrlService);
  const isApi = regional.isWithinEndpoint(request.url, environment.azureApiManagementUrl);
  const isTokenEndpoint = request.url === `${environment.ssoUrl}identity/connect/token`;

  if (!isApi && !isTokenEndpoint) {
    return next(request);
  }

  const region = (localStorage.getItem(LocalStorageKey.DataCenterPrefix) || '').toUpperCase();
  const routed = request.clone({
    url: regional.forRegion(request.url, region),
    context: request.context.set(SIGNAGE_API, isApi)
  });
  return isTokenEndpoint ? next(routed).pipe(timeout(30_000)) : next(routed);
};
